import { trigger } from '@angular/animations';

import { DecimalPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  computed,
  inject,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { maxHeightIf } from '../../../animations/max-height.if.animation';
import { moveLeftIf } from '../../../animations/move-left.if.animation';
import { ArchiveService } from '../../../services/archive.service';
import { CircleProgressBarComponent } from '../../../shared/components/circle-progress-bar/circle-progress-bar.component';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { DataUnitsBigIntPipe } from '../../../shared/pipes/data-units-big-int.pipe';

@Component({
  selector: 'app-archive-download-info',
  templateUrl: './archive-download-info.component.html',
  styleUrls: ['./archive-download-info.component.scss'],
  animations: [
    trigger('archiveBox', moveLeftIf),
    trigger('archiveBody', maxHeightIf(200)),
    trigger('downloadItem', maxHeightIf(60)),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SvgComponent,
    CircleProgressBarComponent,
    LoadingIndicatorComponent,
    ButtonDirective,
    TooltipDirective,
    DataUnitsBigIntPipe,
    DecimalPipe,
  ],
})
export class ArchiveDownloadInfoComponent implements OnInit, OnDestroy {
  public archiveService = inject(ArchiveService);
  private check = inject(ChangeDetectorRef);
  destroyed$ = new Subject<void>();
  totalSize = computed(() =>
    this.archiveService.items().reduce((acc, item) => acc + BigInt(item.archive.total_size), 0n)
  );

  ngOnInit() {
    this.archiveService.onArchiveProgress$.pipe(takeUntil(this.destroyed$)).subscribe(item => {
      if (!item) return;
      this.check.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
